<template lang="pug">
    include ../../media/pug/mixins.pug
    +b.ASIDE.sidebar(
        v-if="$route.params.id"
        v-bind:class="{ 'sidebar_is_сlose': !isSidebarVisible}"
        ref="resizeContainer"
        v-bind:style="{width: `${width}px`}"
    )
        rsl-viewer-menu(
            ref='sideBarMenu'
            v-bind:navList="visibleSidebarMenu"
            v-bind:currentTab="getCurrentSidebarTab"
            theme="orange"
            v-on:newComponent="changeTab"
        )
        +e.content(v-show="isSidebarContentVisible")
            +e.tabs
                transition(name='fade' mode='out-in')
                    keep-alive
                        the-viewed-documents(v-if="getCurrentSidebarTab === 'ViewedDocuments' && isMobile")
                        dynamic-component(
                            v-else-if="getCurrentSidebarTab && getCurrentSidebarTab !== 'ViewedDocuments'"
                            v-bind:data="{width}"
                            v-bind:path="`modules/${getCurrentSidebarTab}`"
                            :key='getCurrentSidebarTab'
                        )
            +e.resize-block(
                ref="resizeNav"
                v-on:mousedown="move($event)"
            )
            +e.bg(v-on:click="setVisible(false)")
        +e.BUTTON.less-btn.btn(
            v-show="isSidebarContentVisible"
            type="button"
            v-on:click="setVisible(!isSidebarVisible);"
        )

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import RslViewerMenu from '@RSL/RslViewerMenu/RslViewerMenu';
import DynamicComponent from '@/components/DynamicComponent';
import documentView from '@/helpers/mixins/document-view';

const TheViewedDocuments = () => import('@/components/document-views/TheViewedDocuments');

export default {
    components: {
        DynamicComponent,
        RslViewerMenu,
        TheViewedDocuments
    },
    mixins: [documentView],
    data() {
        return {
            isClosed: false,
            left: 0,
            width: 420,
            savedWidth: 420,
            maxRight: 580,
            maxLeft: 430,
            sidebarMenuWidth: 0
        };
    },
    computed: {
        sidebarMenu() {
            return [
                {
                    name: 'PreviewViewer',
                    icon: '/sprite.svg#tumbnail',
                    isDisabled: !this.$route.params.id,
                    isHidden: !this.getGeneralInfo.isLogin && !this.$route.params.id
                },
                {
                    name: 'TextSearch',
                    icon: '/sprite.svg#search',
                    isDisabled: !this.$route.params.id,
                    isHidden: !this.getGeneralInfo.isLogin && !this.$route.params.id
                },
                {
                    name: 'ShopCart',
                    icon: '/sprite.svg#cart',
                    hasTopBorder: true,
                    isHidden: true,
                    count: 20
                },
                {
                    name: 'OrdersList',
                    icon: '/sprite.svg#orders',
                    isHidden: true,
                    count: 1
                },
                {
                    name: 'ViewedDocuments',
                    icon: '/sprite.svg#time',
                    isDisabled: !this.$route.params.id,
                    isHidden: true
                },
                {
                    name: 'AvailablePanel',
                    icon: '/sprite.svg#eye',
                    isDisabled: !this.$route.params.id,
                    isHidden: true,
                    hasTopBorder: true
                },
                {
                    name: 'ServicesList',
                    icon: '/sprite.svg#service',
                    isHidden: true
                }
            ];
        },
        visibleSidebarMenu() {
            return this.sidebarMenu.filter(item => !item.isHidden);
        },
        isSidebarContentVisible() {
            if (!this.isMobile) {
                return this.getCurrentSidebarTab !== 'ViewedDocuments';
            }
            return true;
        },
        imgIsFullWidth() {
            const zoom = (+this.getZoom).toFixed(2);
            return (this.$documentView.calcWidth() / this.getMainImageParams.width).toFixed(2) === zoom;
        },
        ...mapGetters([
            'isMobile',
            'isTablet',
            'isDesktop',
            'getZoom',
            'getMainImageParams',
            'getIsSearchable',
            'getGeneralInfo',
            'isSidebarVisible',
            'getCurrentSidebarTab'
        ])
    },
    watch: {
        isSidebarVisible(visible) {
            if (this.isDesktop) {
                this.calcWidth();
            }
            if (visible) {
                if (!this.getCurrentSidebarTab && this.$route.params.id) {
                    this.setTab(this.sidebarMenu[0].name);
                }
            }
        },
        isMobile(value) {
            this.errorComponentTabs(value);
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        if (this.isMobile) {
            this.setVisible(true);
        }
        if (!this.$route.params.id) {
            this.errorComponentTabs(this.isMobile);
        }
    },
    mounted() {
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        ...mapMutations({
            setVisible: 'SET_SIDEBAR_IS_VISIBLE',
            setTab: 'SET_CURRENT_SIDEBAR_TAB'
        }),
        errorComponentTabs(isMobile) {
            // Если у нас выведен компонент ошибки, то мы будем отслеживать табу для мобильного
            // и закрывать сайдбар для десктопа
            if (!this.$route.params.id) {
                const newTab = !isMobile ? '' : 'ServicesList';
                this.$store.commit('SET_CURRENT_SIDEBAR_TAB', newTab);
                if (!isMobile) this.$store.commit('SET_SIDEBAR_IS_VISIBLE', false);
            }
        },
        changeTab(value) {
            if (value !== this.getCurrentSidebarTab) {
                this.setTab(value);
            }
            if (!this.isSidebarVisible && this.isSidebarContentVisible) {
                this.setVisible(true);
            }
            if (this.isSidebarVisible && !this.isSidebarContentVisible) {
                this.setVisible(false);
            }
        },
        calcWidth() {
            if (this.isSidebarVisible && this.isSidebarContentVisible) {
                this.width = this.savedWidth;
            } else {
                this.width = this.sidebarMenuWidth;
            }
            this.handleImgFullWidth();
        },
        handleResize() {
            this.sidebarMenuWidth = this.$refs.sideBarMenu.$el.clientWidth;
            if (!this.isDesktop) {
                this.width = window.innerWidth;
            } else {
                this.calcWidth();
            }
        },
        handleImgFullWidth() {
            if (this.imgIsFullWidth) {
                this.$nextTick(() => {
                    this.$documentView.setFullWidth();
                });
            }
        },
        move(event) {
            const { resizeContainer } = this.$refs;
            const moveElem = this.$refs.resizeNav;
            let prevPosition = event.clientX;
            const maxSize = this.maxRight;
            const mousemove = (e) => {
                const reviewPosition = e.clientX - resizeContainer.getBoundingClientRect().left;
                if (reviewPosition > this.maxLeft && reviewPosition < maxSize) {
                    if (prevPosition < e.clientX) {
                        this.width += e.clientX - prevPosition;
                    }
                    if (prevPosition > e.clientX) {
                        this.width -= prevPosition - e.clientX;
                    }
                } else if (reviewPosition < this.maxLeft) {
                    this.width = this.maxLeft;
                } else if (reviewPosition > maxSize) {
                    this.width = maxSize;
                }
                this.handleImgFullWidth();
                prevPosition = e.clientX;
                this.savedWidth = this.width;
            };
            const mouseup = () => {
                window.removeEventListener('mousemove', mousemove);
                window.removeEventListener('mouseup', mouseup);
                moveElem.removeEventListener('mouseup', mouseup);
            };
            window.addEventListener('mousemove', mousemove);
            moveElem.addEventListener('mouseup', mouseup);
            window.addEventListener('mouseup', mouseup);
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/partials/sidebar.sass"></style>
